function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from "react";
import { Button, Dialog, Intent } from "@blueprintjs/core";
import { renderOnDoc } from "../utils/renderOnDoc";
import DialogFooter from "../DialogFooter"; // usage
// const doAction = await showConfirmationDialog({
//   text:
//     "Are you sure you want to re-run this tool? Downstream tools with linked outputs will need to be re-run as well!",
//     intent: Intent.DANGER, //applied to the right most confirm button
//     confirmButtonText: "Yep!",
//     cancelButtonText: "Nope",
//     canEscapeKeyCancel: true //this is false by default
// });
// console.info("doAction:", doAction);
// const doAction = await showConfirmationDialog({
//   thirdButtonText: 'Click me'
//   thirdButtonIntent: 'primary'
// });
// console.info("doAction:", doAction); //logs thirdButtonClicked
//returns a promise that resolves with true or false depending on if the user cancels or not!

export default function showConfirmationDialog(opts) {
  return new Promise(function (resolve) {
    renderOnDoc(function (handleClose) {
      return /*#__PURE__*/React.createElement(AlertWrapper, _extends({}, opts, {
        handleClose: handleClose,
        resolve: resolve
      }));
    });
  });
}

var AlertWrapper = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AlertWrapper, _Component);

  function AlertWrapper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: true
    });

    return _this;
  }

  var _proto = AlertWrapper.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        handleClose = _this$props.handleClose,
        text = _this$props.text,
        resolve = _this$props.resolve,
        noCancelButton = _this$props.noCancelButton,
        content = _this$props.content,
        className = _this$props.className,
        thirdButtonText = _this$props.thirdButtonText,
        thirdButtonIntent = _this$props.thirdButtonIntent,
        fourthButtonText = _this$props.fourthButtonText,
        fourthButtonIntent = _this$props.fourthButtonIntent,
        canEscapeKeyCancel = _this$props.canEscapeKeyCancel,
        _this$props$confirmBu = _this$props.confirmButtonText,
        confirmButtonText = _this$props$confirmBu === void 0 ? "OK" : _this$props$confirmBu,
        _this$props$cancelBut = _this$props.cancelButtonText,
        cancelButtonText = _this$props$cancelBut === void 0 ? "Cancel" : _this$props$cancelBut,
        _this$props$intent = _this$props.intent,
        intent = _this$props$intent === void 0 ? Intent.PRIMARY : _this$props$intent,
        rest = _objectWithoutPropertiesLoose(_this$props, ["handleClose", "text", "resolve", "noCancelButton", "content", "className", "thirdButtonText", "thirdButtonIntent", "fourthButtonText", "fourthButtonIntent", "canEscapeKeyCancel", "confirmButtonText", "cancelButtonText", "intent"]);

    var doClose = function doClose(confirm) {
      handleClose();

      _this2.setState({
        isOpen: false
      });

      resolve(confirm);
    };

    return /*#__PURE__*/React.createElement(Dialog, _extends({
      className: "bp3-alert " + (className || ""),
      isOpen: this.state.isOpen,
      intent: intent,
      cancelButtonText: cancelButtonText,
      onCancel: cancelButtonText ? function () {
        return doClose(false);
      } : undefined,
      onConfirm: function onConfirm() {
        return doClose(true);
      }
    }, rest, noCancelButton && {
      onCancel: undefined,
      cancelButtonText: undefined
    }), /*#__PURE__*/React.createElement("div", {
      className: "bp3-alert-contents",
      style: {
        padding: 5
      }
    }, content, text && /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: 10
      }
    }, text)), /*#__PURE__*/React.createElement(DialogFooter, {
      onBackClick: cancelButtonText && !noCancelButton ? function () {
        return doClose(false);
      } : undefined,
      onClick: function onClick() {
        return doClose(true);
      },
      noCancel: true,
      additionalButtons: thirdButtonText || fourthButtonText ? /*#__PURE__*/React.createElement(React.Fragment, null, !!fourthButtonText && /*#__PURE__*/React.createElement(Button, {
        intent: fourthButtonIntent,
        text: fourthButtonText,
        onClick: function onClick() {
          doClose("fourthButtonClicked");
        }
      }), !!thirdButtonText && /*#__PURE__*/React.createElement(Button, {
        intent: thirdButtonIntent,
        text: thirdButtonText,
        onClick: function onClick() {
          doClose("thirdButtonClicked");
        }
      })) : undefined,
      containerClassname: "bp3-alert-footer",
      backText: noCancelButton ? "" : cancelButtonText,
      text: confirmButtonText,
      intent: intent
    }));
  };

  return AlertWrapper;
}(Component);